<template>
  <b-container
    class="d-flex flex-column justify-content-center align-items-center p-container-access"
  >
    <div
      :class="`${loading ? 'd-flex' : 'd-none'} overlay justify-content-center align-items-center`"
    >
      <Loading />
    </div>

    <b-col
      class="d-flex flex-column justify-content-center"
      :style="{
        position: 'initial'
      }"
    >
      <Socials
        :is-login="emailMode === 'login'"
        :col="false"
        :purchase-mode="true"
        @login="login"
        @loginWithGoogle="loginWithGoogle"
        @loginWithFacebook="loginWithFacebook"
      />

      <div class="d-flex justify-content-center align-items-center my-2 w-100">
        <div class="line"></div>
        <div class="mx-2 small">or</div>
        <div class="line"></div>
      </div>

      <LoginForm
        v-if="emailMode === 'login'"
        @loading="(status) => (loading = status)"
        @login="login"
      />

      <SignUpForm
        v-if="emailMode === 'signup'"
        @loading="(status) => (loading = status)"
        @signup="login"
      />

      <div v-if="emailMode === 'login' && !loading" class="mt-3 extra-small text-dim-gray">
        {{ $t('profile.signUp.main.dontHaveAccount') }}
        <span
          role="button"
          class="text-gray-800 cursor-pointer"
          @click="() => (emailMode = 'signup')"
          >{{ $t('profile.signUp.main.title') }}</span
        >
      </div>

      <div v-if="emailMode === 'signup' && !loading" class="mt-3 extra-small text-dim-gray">
        <div>
          {{ $t('profile.logIn.main.alreadyHaveAccount') }}
          <span
            role="button"
            class="text-gray-800 cursor-pointer"
            @click="() => (emailMode = 'login')"
            >{{ $t('profile.logIn.main.title') }}</span
          >
        </div>
        <div class="mt-2">
          {{ $t('profile.signUp.main.terms1') }}
          <a
            href="/terms-and-conditions/"
            target="_blank"
            class="text-dim-gray text-decoration-underline"
          >
            {{ $t('profile.signUp.main.terms2') }}
          </a>
          {{ $t('profile.signUp.main.terms3') }}
          <a
            href="/privacy-policy/"
            target="_blank"
            class="text-dim-gray text-decoration-underline"
          >
            {{ $t('profile.signUp.main.terms4') }}
          </a>
        </div>
      </div>
    </b-col>
  </b-container>
</template>

<script>
import Loading from 'UI/Loading';
import Socials from '@/components/User/Form/Socials';
const LoginForm = () => import('@/components/User/Form/LoginForm');
const SignUpForm = () => import('@/components/User/Form/SignUpForm');
export default {
  components: {
    LoginForm,
    SignUpForm,
    Loading,
    Socials
  },
  props: {
    afterLogin: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      emailMode: 'signup',
      loading: false
    };
  },
  mounted() {
    this.$auth.init();
  },
  methods: {
    login() {
      this.setAfterLoginCookie();
      this.$emit('login');
    },
    setAfterLoginCookie() {
      if (this.afterLogin && this.afterLogin != '') {
        this.$cookies.set('afterLoginRedirect', this.afterLogin);
      }
    },
    loginWithGoogle() {
      this.$dataLayerPush('purchase_flow_login_with', {
        provider: 'google'
      });
    },
    loginWithFacebook() {
      this.$dataLayerPush('purchase_flow_login_with', {
        provider: 'facebook'
      });
    },
    loginWithEmail() {
      this.$dataLayerPush('purchase_flow_login_with', {
        provider: 'email'
      });
      this.showEmail = true;
    },
    emailBack() {
      this.$dataLayerPush('purchase_flow_email_back');
      this.showEmail = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.text-decoration-underline {
  text-decoration: underline;
}
.p-container-access {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 15px;
  padding-right: 15px;

  @media (min-width: 768px) {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }
}

.extra-small {
  font-size: 12px;
}

.text-dim-gray {
  color: $gray-700;
}

.text-gray-800 {
  color: $gray-800;
}

.line {
  width: 100%;
  height: 2px;
  background-color: $lightGray;
}

.continue-to-subscribe {
  font-weight: bold;
}
.login-with-email {
  padding-top: 1em;
  padding-bottom: 1em;
}
.overlay {
  display: none;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 10;
  position: absolute;
  margin-top: 24px;
  border-radius: 3px;
}
.button {
  color: gray;
  cursor: pointer;
  border-radius: 30px;
  background-color: $lightGray;
  span {
    font-size: 12px;
    white-space: nowrap;
  }
  &.login-with-email {
    span {
      color: black !important;
      font-size: 14px !important;
    }
  }
}
</style>
